import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["pagination", 'loadMore', 'loadingIndicator']

  connect() {
    this.intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadMore()
        }
      })
    })

    this.intersectionObserver.observe(this.paginationTarget)
  }

  disconnect() {
    this.intersectionObserver.disconnect()
  }

  loadMore() {
    if (this.hasLoadMoreTarget) {
      this.loadMoreTarget.click()
      this.loadMoreTarget.classList.add('hidden')
      this.loadingIndicatorTarget.classList.remove('hidden')
    }
  }
}
